// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

  if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);

        // Add some additional logging to localhost, pointing developers to the
        // service worker/PWA documentation.
        navigator.serviceWorker.ready.then(() => {
          /*console.log(
            'This web app is being served cache-first by a service ' +
              'worker. To learn more, visit https://cra.link/PWA'
          );*/
        });
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
        // After registering, start a lightweight version check loop to detect
        // new deploys (works even if SW file was cached by intermediaries).
        // It fetches /version.json (no-cache) and if the version differs it
        // calls registration.update() to prompt the SW install flow.
        try {
          // delay a bit to avoid network storm on load
          setTimeout(() => {
            // run one initial check and then periodic checks
            navigator.serviceWorker.getRegistration().then((reg) => {
              if (!reg) return;
              const checkOnce = async () => {
                try {
                  const resp = await fetch('/version.json', { cache: 'no-store' });
                  if (!resp.ok) return;
                  const data = await resp.json();
                  const current = sessionStorage.getItem('app-version');
                  if (data && data.version && data.version !== current) {
                    sessionStorage.setItem('app-version', data.version);
                    // Ask SW to update (will trigger install if updated)
                    try { await reg.update(); } catch (e) {}
                    // If a waiting worker exists, tell it to skip waiting
                    if (reg.waiting) {
                      try { reg.waiting.postMessage({ type: 'SKIP_WAITING' }); } catch (e) {}
                    }
                  }
                } catch (e) {
                  // ignore network errors
                }
              };
              // initial
              checkOnce();
              // then periodic every 5 minutes
              setInterval(checkOnce, 5 * 60 * 1000);
            });
          }, 3000);
        } catch (e) {
          // ignore
        }
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the updated precached content has been fetched.
              // We'll try to activate the new service worker immediately by
              // asking it to skipWaiting, then reload the page once it takes control.
              try {
                // Inform the waiting worker to skip waiting and activate.
                if (registration.waiting) {
                  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                }
              } catch (e) {
                // ignore
              }

              // Guard to avoid reload loops in the same session
              const RELOAD_FLAG = 'sw-reloaded-on-update';
              if (!sessionStorage.getItem(RELOAD_FLAG)) {
                const onControllerChange = () => {
                  // Ensure we only reload once per session
                  sessionStorage.setItem(RELOAD_FLAG, '1');
                  window.location.reload();
                };
                navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
              }

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              //console.log('Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      //console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
